import { Reveal, Eyebrow } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const STATS = [
  { label: "about.bornOn", value: "Solana" },
  { label: "about.tax", value: "0% / 0%" },
  { label: "about.lp", value: "about.lpValue" },
  { label: "about.supply", value: "1B" },
];

export const About = () => {
  const { t } = useLanguage();
  return (
  <section id="about" className="scroll-mt-24 px-5 py-24 sm:px-8">
    <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Reveal>
          <Eyebrow>{t("about.eyebrow")}</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display mt-5 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            {t("about.t1")}{" "}
            <span className="text-flow">{t("about.t2")}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-gray-300 sm:text-lg">
            {t("about.body")}
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="font-display mt-5 text-lg font-bold text-[#F5F3FF] sm:text-xl">
            {t("about.join")}
          </p>
          <p className="mt-3 text-xs text-gray-500">{t("about.risk")}</p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {STATS.map((s) => (
              <div
                key={s.label}
                className="rounded-2xl border border-purple-500/15 bg-[#0E0E16] p-4 transition-colors hover:border-purple-500/40"
              >
                <div className="font-display text-[11px] font-bold uppercase tracking-[0.15em] text-gray-500">
                  {t(s.label)}
                </div>
                <div className="font-display text-flow mt-1 text-lg font-extrabold sm:text-xl">
                  {s.value.startsWith("about.") ? t(s.value) : s.value}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-5">
        <Reveal delay={0.15}>
          <div className="relative mx-auto max-w-sm -rotate-2 rounded-[2rem] border border-purple-500/25 bg-[#0E0E16] p-3 shadow-[0_0_60px_rgba(153,69,255,0.25)] transition-transform duration-500 hover:rotate-0">
            <img
              src="/mascots/cow-sunset.png"
              alt="SOLMOO cow grazing at sunset"
              className="w-full rounded-3xl object-cover"
            />
            <span className="bg-solana-gradient font-display absolute -top-3 right-6 rounded-full px-4 py-1.5 text-xs font-bold text-white shadow-lg">
              {t("about.badge")}
            </span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
